
import { useState } from 'react';
import Hero from './components/Hero';
import QuoteForm from './components/QuoteForm';
import ContactInfo from './components/ContactInfo';

export default function QuotePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <QuoteForm />
          </div>
          <div className="lg:col-span-1">
            <ContactInfo />
          </div>
        </div>
      </div>
    </div>
  );
}
